var ProjectName = {
    init: function () {
        this.win = $(window);
        this.html = $('body');
        this.btnToggleNav = $('#nav-toggle');
        this.btnToggleSearch = $('#search-toggle');
        this.btnToggleFilters = $('#filters-toggle');
        this.subNavToggle = $('.menu-item-has-children');
        this.subNavToggleLink = $('.menu-item-has-children > a');
        this._initFoundation();
        this._bindEvent();
        this._stickyHeader();
        this._resize();
    },
    _initFoundation: function () {
        $(document).foundation();
    },
    _bindEvent: function () {
        ProjectName.btnToggleNav.on('click', function (e) {
            ProjectName._toggleNav(e);
        });
        ProjectName.subNavToggleLink.on('click', function (e) {
            ProjectName._subNavToggle(e, $(this).closest('.menu-item-has-children'));
        });
        ProjectName.btnToggleSearch.on('click', function (e) {
            ProjectName._toggleSearch(e);
        });
        ProjectName.btnToggleFilters.on('click', function (e) {
            ProjectName._toggleFilters(e);
        });
    },
    _resize: function () {
        $(window).on('resize', function () {
            var win = $(document);
            if (win.width() >= 768) {
                if (ProjectName.html.hasClass('navigation-open')) {
                    ProjectName.html.removeClass('navigation-open');
                }
                ProjectName.subNavToggle.removeClass('subnav-open');
            }
        });
    },
    _toggleNav: function (e) {
        e.stopPropagation();
        if (ProjectName.html.hasClass('navigation-open')) {
            ProjectName.html.removeClass('navigation-open');
        } else {
            ProjectName.html.addClass('navigation-open');
        }
    },
    _subNavToggle: function (e, item) {
        var $isMobile = false; //initiate as false
        // device detection
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
            $isMobile = true;
        }

        if($isMobile && item.hasClass('level0')){
            e.preventDefault();
            e.stopPropagation();
        } else {
            if(!item.hasClass('level0')){
                e.preventDefault();
                e.stopPropagation();
            }
        }

        if (item.hasClass('subnav-open')) {
            item.removeClass('subnav-open');
        } else {
            item.addClass('subnav-open');
        }
    },
    _toggleStickyNav: function () {
        if (ProjectName.html.hasClass('navigation-sticky')) {
            ProjectName.html.removeClass('navigation-sticky');
        } else {
            ProjectName.html.addClass('navigation-sticky');
        }
    },
    _stickyHeader: function () {
        var waypoint = new Waypoint({
            element: document.getElementById('sticky-hook'),
            handler: function (direction) {
                ProjectName._toggleStickyNav();
            }
        });
    },
    _toggleSearch: function (e) {
        e.stopPropagation();
        if (ProjectName.html.hasClass('search-open')) {
            ProjectName.html.removeClass('search-open');
        } else {
            ProjectName.html.addClass('search-open');
            $(".search-box__input").focus();
        }
    },
    _toggleFilters: function (e) {
        e.stopPropagation();
        if (ProjectName.html.hasClass('filters-open')) {
            ProjectName.html.removeClass('filters-open');
        } else {
            ProjectName.html.addClass('filters-open');            
        }
    },
}

jQuery(window).on('resize', function () {

});



jQuery(document).ready(function () {


    ProjectName.init();

    if ( $( "#list-expertise" ).length ) {
        
        var waypoint = new Waypoint({
            element: document.getElementById('list-expertise'),
            handler: function (direction) {
                $('#list-expertise').addClass('list-expertise__hook');
                this.destroy();
            },
            offset: 'bottom-in-view'
        });
        
    }

    var sliderQuoteImage = $('.slider-quote__image');
    window['slider-quote__image'] = sliderQuoteImage;
    var sliderQuoteCaption = $('.slider-quote__caption');
    window['slider-quote__caption'] = sliderQuoteCaption;

    if ( $( ".slider-quote__image" ).length ) {

        var index = (sliderQuoteImage.find('li').length == 1) ? 0 : 1;
        sliderQuoteImage.find('li').eq(index).addClass('active-slide');

        sliderQuoteImage.bxSlider({
            startSlide: index,
            infiniteLoop: false,
            touchEnabled: false,
            easing: 'ease',
            speed: 600,
            pager: false,
            nextSelector: '#slider-quote-next',
            prevSelector: '#slider-quote-prev',
            nextText: '<i class="far fa-arrow-right">',
            prevText: '<i class="far fa-arrow-left">',
            onSlideAfter: function ($slideElement, oldIndex, newIndex) {
                $('.active-slide').removeClass('active-slide');
                $slideElement.addClass('active-slide');
                sliderQuoteCaption.goToSlide(newIndex);
            }
        });
        sliderQuoteCaption.bxSlider({
            startSlide: index,
            mode: 'fade',
            easing: 'ease',
            speed: 300,
            infiniteLoop: false,
            touchEnabled: false,
            adaptiveHeight: true,
            pager: false
        });
    
    }

    if(navigator.userAgent.toLowerCase().indexOf("firefox") > -1 || getInternetExplorerVersion() > 0){
        $('button[class*="nav-next"]').click(function () {
            var parts = $(this).attr('class').split('__');
            var className = parts[0]+'__image';
            window[className].goToNextSlide();
        });
        $('button[class*="nav-prev"]').click(function () {
            var parts = $(this).attr('class').split('__');
            var className = parts[0]+'__image';
            window[className].goToPrevSlide();
        });
    }

    var sliderBannerImage = $('.slider-banner__image');
    var sliderBannerCaption = $('.slider-banner__caption');

    if ( $( ".slider-banner__image" ).length ) {
        sliderBannerImage.bxSlider({
            startSlide: 0,
            easing: 'ease',
            mode: 'fade',
            speed: 1000,
            pause: 7000,
            auto: true,
            touchEnabled: true,
            controls: false,
        });
        /*sliderBannerCaption.bxSlider({
            easing: 'ease',
            speed: 1500,
            mode: 'vertical',
            adaptiveHeight: true,
            controls: false,
            touchEnabled: false,
            onSlideBefore: function ($slideElement, oldIndex, newIndex) {
                sliderBannerImage.goToSlide(newIndex);
                $('#slider-banner-more').attr('href', $slideElement.data('link'));
            }
        });*/

        sliderBannerImage.reloadSlider();
        //sliderBannerCaption.reloadSlider();
    }

    var sliderPostsImage = $('.slider-posts__image');
    window['slider-posts__image'] = sliderPostsImage;
    var sliderPostsCaption = $('.slider-posts__caption');
    window['slider-posts__caption'] = sliderPostsCaption;

    if ( $( ".slider-posts__image" ).length ) {

        sliderPostsImage.bxSlider({
            mode: 'fade',
            easing: 'ease',
            speed: 900,
            controls: false,
            touchEnabled: false,
            onSlideBefore: function ($slideElement, oldIndex, newIndex) {
                sliderPostsCaption.goToSlide(newIndex);
            }
        });

        var $block = $('.landing-block-3');
        var callback = function($slideElement) {

            var $content = $slideElement || $block.find('.slider-posts__description[aria-hidden=false]').first();
            var $btn = $block.find('#slider-posts-more');
            var $mobile_btn = $content.find('.button-more');

            var $link = $content.find('.slide-link a');
            if ($link.length) {
                $btn.attr('href', $link.attr('href')).text($link.text());
                $mobile_btn.attr('href', $link.attr('href')).text($link.text());
            } else {
                //$btn.hide();
                //$mobile_btn.hide();
            }
        };

        sliderPostsCaption.bxSlider({
            easing: 'ease',
            speed: 900,
            nextSelector: '#slider-posts-next',
            prevSelector: '#slider-posts-prev',
            nextText: '<i class="far fa-arrow-right">',
            prevText: '<i class="far fa-arrow-left">',
            onSlideBefore: function ($slideElement, oldIndex, newIndex) {
                sliderPostsImage.goToSlide(newIndex);
                $('#slider-posts-more').attr('href', $slideElement.data('link'));
                callback($slideElement)
            },
            onSliderLoad: callback
        });

        sliderPostsImage.reloadSlider();
        sliderPostsCaption.reloadSlider();
    }


    var sliderProjectsImage = $('.slider-projects__image');
    window['slider-projects__image'] = sliderProjectsImage;
    var sliderProjectsCaption = $('.slider-projects__caption');
    window['slider-projects__caption'] = sliderProjectsCaption;

    if ( $( ".slider-projects__image" ).length ) {

        sliderProjectsImage.bxSlider({
            mode: 'fade',
            easing: 'ease',
            speed: 900,
            controls: false,
            touchEnabled: false,
            onSlideBefore: function ($slideElement, oldIndex, newIndex) {
                sliderProjectsCaption.goToSlide(newIndex);
            }
        });
        sliderProjectsCaption.bxSlider({
            easing: 'ease',
            speed: 900,
            nextSelector: '#slider-projects-next',
            prevSelector: '#slider-projects-prev',
            nextText: '<i class="far fa-arrow-right">',
            prevText: '<i class="far fa-arrow-left">',
            onSlideBefore: function ($slideElement, oldIndex, newIndex) {
                sliderProjectsImage.goToSlide(newIndex);
                $('#slider-projects-more').attr('href', $slideElement.data('link'));
            }
        });

        sliderProjectsImage.reloadSlider();
        sliderProjectsCaption.reloadSlider();
    }

    var sliderListPosts = $('.slider-list-posts');
    window['slider-list-posts'] = sliderListPosts;

    if ( $( ".slider-list-posts" ).length ) {

        sliderListPosts.bxSlider({
            minSlides: 4,
            maxSlides: 4,
            moveSlides: 1,
            slideSelector: 'li.list-item',
            slideWidth: 306,
            easing: 'ease',
            speed: 900,
            touchEnabled: false,
            nextSelector: '#slider-list-next',
            prevSelector: '#slider-list-prev',
            nextText: '<i class="far fa-arrow-right">',
            prevText: '<i class="far fa-arrow-left">',
        });

        sliderListPosts.reloadSlider();
    }


});

function getInternetExplorerVersion()
{
    var rv = -1;
    if (navigator.appName == 'Microsoft Internet Explorer')
    {
        var ua = navigator.userAgent;
        var re = new RegExp("MSIE ([0-9]{1,}[\\.0-9]{0,})");
        if (re.exec(ua) != null)
            rv = parseFloat( RegExp.$1 );
    }
    else if (navigator.appName == 'Netscape')
    {
        var ua = navigator.userAgent;
        var re  = new RegExp("Trident/.*rv:([0-9]{1,}[\\.0-9]{0,})");
        if (re.exec(ua) != null)
            rv = parseFloat( RegExp.$1 );
    }
    return rv;
}

$(window).click(function (e) {
    if (($('body').hasClass('search-open')) && (!$(e.target).hasClass('search-box__item'))) {
        ProjectName._toggleSearch(e);
    }
});

$(function () {
    $(".scroll-top").click(function () {
        $("html,body").animate(
                {scrollTop: $("body").offset().top}
        , "3300");
        return false;
    })
});


jQuery(document).ready(function () {
    $('.views-exposed-form.bef-exposed-form').appendTo('.filters__filters');

    $('.nav-pills .nav-item:first').addClass('active');
    $('.tab-content .tab-pane:first').addClass('active in');
          
});